import { render, staticRenderFns } from "./cxAutoClaim.vue?vue&type=template&id=ae473b7c&scoped=true&"
import script from "./cxAutoClaim.vue?vue&type=script&lang=js&"
export * from "./cxAutoClaim.vue?vue&type=script&lang=js&"
import style0 from "./cxAutoClaim.vue?vue&type=style&index=0&id=ae473b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae473b7c",
  null
  
)

export default component.exports